import { AuthenticationService } from './../../services/authentication.service';
import { Publication } from './../../interfaces/publication';
import { PublicationService } from './../../services/publication.service';
import { Component, ChangeDetectionStrategy, ChangeDetectorRef, OnInit } from '@angular/core';
import { BbAbstractMenuComponent } from '../shared/bb-abstract-menu/bb-abstract-menu.component';
import { RouterEvent, NavigationEnd } from '@angular/router';


@Component({
	selector: 'bb-analytics-menu',
	templateUrl: './bb-analytics-menu.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush
})

export class BbAnalyticsMenuComponent extends BbAbstractMenuComponent implements OnInit {
	ovpTypeAdServices = false;
	rootPermission = false;

	constructor(
		private changeDetector: ChangeDetectorRef,
		private authenticationService: AuthenticationService,
		private publicationService: PublicationService
	) {
		super(['project']);
	}

	ngOnInit() {
		this.subscriptions.add(this.router.events.subscribe((routerEvent: RouterEvent) => {
			if (routerEvent instanceof NavigationEnd) {
				this.changeDetector.detectChanges();
			}
		}));
		this.subscriptions.add(this.publicationService.getData().subscribe((publication: Publication) => {
			this.ovpTypeAdServices = publication?.ovpType === 'advertising services';
		}));
		this.subscriptions.add(this.authenticationService.hasPermission('root').subscribe((hasRight: boolean) => this.rootPermission = hasRight));
	}
}
